import * as React from 'react';
import * as b_ from 'b_';
import { useTranslation } from 'react-i18next';
import SingleTooltip from 'components/SingleTooltip';
import { TooltipContent } from './components/TooltipContent';

import './index.scss';

import * as hint from './static/img/hint.svg';

interface Props {
  notEnoughMoney?: boolean;
}

const b = b_.with('idea-landing-submit-section-ipo-notification');

export const Notification: React.FC<Props> = ({ notEnoughMoney }) => {
  const { t } = useTranslation();

  return (
    <div className={b({ 'not-enough-money': notEnoughMoney })}>
      <span className={b('text')}>
        {t('The recommended minimum investment is $ 2000 - $ 6000')}
      </span>
      <SingleTooltip placement="topRight" content={TooltipContent}>
        <img className={b('icon')} src={hint} alt="" />
      </SingleTooltip>
    </div>
  );
};
